export default __webpack_public_path__ + "static/media/2.b026c714.png";